import { render, staticRenderFns } from "./RequiresAttention.vue?vue&type=template&id=587f6754&"
import script from "./RequiresAttention.vue?vue&type=script&lang=js&"
export * from "./RequiresAttention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports